<template>
  <div class="topVert" id="reseauxLc"
       v-if="detailReseauxLcFilter.length">
    <div class="columns is-marginless">
      <div class="circleStyle">
        <b-icon
        icon="circle"
        size="is-small">
        </b-icon>
      </div>
      <h2 class="has-text-weight-bold">Proposition réseau(x) LC</h2>
    </div>
    <div class="colomn"
      v-for="(reseauxLc, index) in detailReseauxLcFilter"
      :key="index">
      <h3 class="has-text-default has-text-weight-bold topBleu bottomVert">
        {{reseauxLc.libelle}}
      </h3>
      <app-carte-reseaux-lc :detailReseauxLc="reseauxLc"
      :markerReseauxLc="markerReseauxLc"/>
      <app-info-reseaux-lc :infoReseauxLc="reseauxLc"/>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { iconColorGetter, TAILLE_ICON_GRAND } from '@/services/general/iconColorGetter';
import carteReseauxLc from './carteReseauxLc';
import infoReseauxLc from './infoReseauxLc';

export default {
  name: 'index',
  props: ['detailReseauxLc', 'adresseReseauxLc'],
  components: {
    appCarteReseauxLc: carteReseauxLc,
    appInfoReseauxLc: infoReseauxLc,
  },
  data() {
    return {
      markerReseauxLc: {},
    };
  },
  computed: {
    ...mapGetters(['getMaSelection']),
    detailReseauxLcFilter() {
      const data = this.detailReseauxLc.filter(d =>
        !d.extensionOpportunite.reseauPersoGuid);
      if (this.getMaSelection) {
        return data.filter(el => el.select);
      }
      return data;
    },
  },
  methods: {
    generateMarker() {
      if (this.adresseReseauxLc.lat !== undefined) {
        this.markerReseauxLc = {
          ...this.adresseReseauxLc,
          icon: iconColorGetter('#000000', TAILLE_ICON_GRAND, null, false),
        };
      }
    },
  },
  mounted() {
    this.generateMarker();
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/propositions/reseauxLc/index.vue